/**
 * A school session on the web app: a student whose school enrolled them
 * (role 22). Set at login from the API's answer (jwtAuthService.login).
 *
 * DISPLAY AND NAVIGATION ONLY. Which school a request reaches, and what a
 * student may do, is decided by the API from the signed token. Nothing here
 * is sent to the server, and editing sessionStorage changes nothing but what
 * this browser shows.
 */

export const ROLE_SCHOOL_STUDENT = 22;

export interface SchoolIdentity {
  id: number;
  code: string;
  name: string;
  status: string;
}

export const getSchool = (): SchoolIdentity | null => {
  try {
    const raw = sessionStorage.getItem('wiziai_school');
    return raw ? (JSON.parse(raw) as SchoolIdentity) : null;
  } catch {
    return null;
  }
};

export const isSchoolStudent = (): boolean =>
  getSchool() !== null && sessionStorage.getItem('wiziai_role_id') === String(ROLE_SCHOOL_STUDENT);

/** The temporary password from the school has not been replaced yet. */
export const mustChangePassword = (): boolean => sessionStorage.getItem('wiziai_must_change_password') === 'true';

export const clearMustChangePassword = (): void => sessionStorage.removeItem('wiziai_must_change_password');

/** Where a signed-in user lands. */
export const homePath = (): string => (isSchoolStudent() ? '/my-tests' : '/dashboard');
